import * as React from "react";
import { SVGProps } from "react";
const SvgVolumeNormal = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 32 32" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M14 3.26a2 2 0 0 1 2 2v21.48a2 2 0 0 1-3.496 1.328L8 22.998H4a2 2 0 0 1-2-2V11a2 2 0 0 1 2-2h4l4.504-5.068A2.001 2.001 0 0 1 14 3.261V3.26Zm10.029 1.272c.667.468 1.293.992 1.87 1.568a13.909 13.909 0 0 1 4.1 9.9c0 3.739-1.455 7.255-4.1 9.899a14.039 14.039 0 0 1-1.87 1.569.996.996 0 0 1-1.392-.246 1 1 0 0 1 .246-1.392c.572-.4 1.108-.85 1.602-1.345A11.918 11.918 0 0 0 28 16a11.919 11.919 0 0 0-3.515-8.485 12.001 12.001 0 0 0-1.602-1.345 1 1 0 1 1 1.146-1.638Zm-10.03.729-4.505 5.067-.597.671H4v10h4.897l.597.673L14 26.739V5.26l-.001.001Zm6.587 4.185c.382.267.74.567 1.07.896A7.951 7.951 0 0 1 24 16a7.95 7.95 0 0 1-2.342 5.657c-.33.33-.688.63-1.07.897a1 1 0 0 1-1.145-1.64c.286-.2.555-.426.802-.673A5.959 5.959 0 0 0 22 16a5.963 5.963 0 0 0-2.557-4.914 1 1 0 0 1 1.144-1.64h-.001Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgVolumeNormal;
